import { decorate, injectable } from "inversify";
import { Auth, Analytics } from "aws-amplify";
import aws from "./aws-exports";
import { CognitoUserSession } from "amazon-cognito-identity-js";

export class AuthService {
  auth: any;

  constructor() {
    this.auth = Auth;
    Analytics.configure({ disabled: true });

    this.auth.configure(aws.Auth);
  }

  public async getUserAsync() {
    return await this.auth.currentAuthenticatedUser();
  }

  public async getSession(): Promise<CognitoUserSession> {
    return await this.auth.currentSession();
  }

  public async loginAsync(username: string, password: string): Promise<any> {
    return this.auth.signIn(username, password);
  }

  public async changePassword(
    oldpassword: string,
    password: string
  ): Promise<any> {
    const user = await this.auth.currentAuthenticatedUser();
    await this.auth.changePassword(user, oldpassword, password);
  }

  public async completePasswordAsync(
    user: string,
    newPassword: string
  ): Promise<any> {
    await this.auth.completeNewPassword(user, newPassword, null);
  }

  public async isAuthenticatedAsync(): Promise<boolean> {
    return !!(await this.auth.currentUserInfo());
  }

  public async getGroupsAsync(): Promise<string[]> {
    const session = await this.auth.currentSession();
    const idToken = session.getIdToken();
    const payload = idToken.decodePayload();
    return payload["cognito:groups"] || [];
  }

  public logoutAsync(): Promise<any> {
    return this.auth.signOut();
  }
}
decorate(injectable(), AuthService);
